import { ScreenSize } from 'glints-aries';
import styled from 'styled-components';

export const ListContainer = styled.div`
  @media (min-width: ${ScreenSize.tablet}px) {
    min-height: 600px;
  }
`;

export const Header = styled.h1`
  font-size: 22px;
  font-weight: bold;
  margin: 32px 0;
`;

export const LinkList = styled.div`
  margin-bottom: 32px;
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: 32px;
  @media (min-width: ${ScreenSize.tablet}px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (min-width: ${ScreenSize.desktopS}px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const LinkItem = styled.h2`
  font-size: 16px;
  margin-bottom: 8px;
`;

export const CustomHr = styled.hr<{ isInMiddleContainer?: boolean }>`
  ${({ isInMiddleContainer }) =>
    isInMiddleContainer
      ? `
  border: none;
  border-bottom: 1px solid #f3f3f3
`
      : `
  border: solid ;
  border-bottom: 1px #000
`};
`;

export const OuterItem = styled.h2`
  font-size: 22px;
  margin-bottom: 38px;
  font-weight: bold;

  @media (max-width: ${ScreenSize.mobileL}px) {
    font-size: 18px;
  }
`;

export const MiddleContainer = styled.div`
  margin-bottom: 30px;
  margin-top: 30px;

  @media (min-width: ${ScreenSize.desktopS}px) {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
  }

  @media (max-width: ${ScreenSize.mobileL}px) {
    margin-bottom: 18px;
    margin-top: 18px;
  }
`;

export const MiddleItem = styled.h3`
  font-size: 20px;
  margin-right: 30px;
  white-space: nowrap;
  padding-top: 4px;

  @media (max-width: ${ScreenSize.mobileL}px) {
    font-size: 16px;
    padding-bottom: 10px;
  }
`;

export const InnerContainer = styled.ul`
  list-style-type: none;
  padding: 0;
  margin-block-start: 0px;
  margin-block-end: 0px;
  li {
    display: inline-block;
    margin-right: 10px;
    margin-left: 10px;
  }
  h4 {
    font-size: 14px;
  }
  @media (max-width: ${ScreenSize.desktopS}px) {
    li {
      margin-right: 20px;
      margin-left: 0px;
    }
  }

  @media (max-width: ${ScreenSize.mobileL}px) {
    h4 {
      font-size: 12px;
    }
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 50px 0;
  font-size: 40px;
`;
